import { deleteProblem } from '@entities/problem/store.svelte';

export interface DeleteProblemOptions {
  id: string;
  name: string;
  confirm?: (message: string) => boolean;
}

export async function confirmAndDeleteProblem({
  id,
  name,
  confirm = (message) => window.confirm(message),
}: DeleteProblemOptions): Promise<boolean> {
  const proceed = confirm(`課題「${name}」を削除します。この操作は取り消せません。よろしいですか?`);
  if (!proceed) return false;
  await deleteProblem(id);
  return true;
}
